import { AwsRum } from 'aws-rum-web';
import { Component, PropsWithChildren, ReactNode } from 'react';

type TAwsRumErrorBoundaryProps = PropsWithChildren<{ awsRum?: AwsRum; fallbackComponent: ReactNode }>;
interface IThisProps {
  hasError: boolean;
}

export class AwsRumErrorBoundary extends Component<TAwsRumErrorBoundaryProps, IThisProps> {
  constructor(props: TAwsRumErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (this.props?.awsRum) {
      this.props.awsRum.recordError(error);
    }
  }

  render() {
    if (this.state.hasError && this.props.fallbackComponent) {
      return this.props.fallbackComponent;
    }
    return this.props.children;
  }
}
